import { z } from "zod";

export const policyTypeOptions = [
  { label: "Percentage", value: "percentage" },
  { label: "Fixed amount (cents)", value: "amount" },
];

export const createDiscountPolicyId = (): string =>
  typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
    ? crypto.randomUUID()
    : `tmp-${Math.random().toString(36).slice(2, 10)}`;

export type DiscountReasonCodeFormValue = {
  code: string;
  label: string;
  requiresNote: boolean;
};

export type DiscountPolicyFormValue = {
  id: string;
  name: string;
  code: string;
  type: "percentage" | "amount";
  value: number;
  maxStack: number | null;
  stackGroup: string | null;
  allowStacking: boolean;
  approvalRequired: boolean;
  reasonCodes: DiscountReasonCodeFormValue[];
  createdAt: number;
  updatedAt: number;
};

export const discountReasonCodeSchema = z.object({
  code: z.string().trim().min(2).max(32),
  label: z.string().trim().min(2).max(160),
  requiresNote: z.boolean(),
});

export const discountPolicySchema = z.object({
  id: z.string().trim().min(4).max(64),
  name: z.string().trim().min(2).max(160),
  code: z.string().trim().min(2).max(64),
  type: z.enum(["percentage", "amount"]),
  value: z.number().int().min(0).max(100_000),
  maxStack: z.number().int().min(1).max(5).nullable(),
  stackGroup: z
    .string()
    .trim()
    .max(64)
    .nullable(),
  allowStacking: z.boolean(),
  approvalRequired: z.boolean(),
  reasonCodes: z.array(discountReasonCodeSchema).max(20),
  createdAt: z.number().int().min(0),
  updatedAt: z.number().int().min(0),
});

export const discountPoliciesSchema = z.array(discountPolicySchema).max(50);
